import { Component, OnInit, Inject, Input, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MyteamsService } from '../_services/myteams.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
@Component({
  selector: 'app-swapplayers',
  templateUrl: './swapPlayers.component.html',
  styleUrls: ['./swapPlayers.component.scss']
})
export class SwapPlayersComponent implements OnInit {
  isMobile = false;
  playerData: any = [];
  teamData: any = [];
  curplayer: any = {};
  newplayer: any = {};
  curleague: any = {};
  movePlayer: any = null;
  rosterPositions: any = {};
  curFilter: any = {
    pname: 'All'
  };
  curSearch = '';
  curTeam = '';
  animationState = 'in';
  searchMode = true;
  showLoader = false;
  searchTimer: any = null;
  filteredPlayers = [];
  user: any = {};
  session_id = '';
  swap: any = {};
  swappedPlayers: any = {};
  colorCodes = {};
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  assetsURL = `${environment.assetURL}/assets/`;
  games = {
    0: 'all',
    1: 'nhl',
    2: 'nfl',
    3: 'mlb',
    4: 'nba',
    5: 'pga'
  };
  browsername='';
  isMac = false;

  @ViewChild('searchInput') searchElement: ElementRef;
  constructor(private store: Store<any>, public MyteamsService: MyteamsService, private spinner: NgxSpinnerService, private deviceService: DeviceDetectorService, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data, public dialogRef: MatDialogRef<SwapPlayersComponent>) {
    
  if (navigator.appVersion.indexOf("Mac")!=-1) this.isMac =true;
    if (navigator.userAgent.match(/AppleWebKit/) && ! navigator.userAgent.match(/Chrome/)) {
      this.browsername = 'safaribrowser';
   }
   this.curplayer = data.player;
    this.movePlayer = data.movePlayer;
    this.curleague = data.league;
    this.isMobile = this.deviceService.isMobile();
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.user = state[0];
      }
    });
  }

  ngOnInit() {
    this.getPlayerData();
  }

  ngOnChanges(e) {
    // need to detect input changes for user, parentPage
  }

  ngOnDestroy() {

  }

  getPlayerData() {
    this.spinner.show();
    let postData = { "action": "remove", "pposition": this.movePlayer!=null?this.movePlayer.pick_cabbr:this.curplayer.pick_cabbr, "league_uuid": this.curleague.id, "user_uuid": this.curplayer.lgm_id, "player_uuid": this.curplayer.id };
    this.MyteamsService.addPlayerToSwap(postData).subscribe(res => {
      if (res.swap_status) {
        this.session_id = res.session_id;
        this.MyteamsService.getSwapPlayerData(this.curleague.id, this.user.id, this.session_id).subscribe(data => {
          if (data['status'] == true) {
            let res = data['entities'];
            this.playerData = res.players;
            this.teamData = res.teams;
            this.rosterPositions = res.roster_position;
            this.rosterPositions.forEach(position => {
              const colorCode = position.color_code.split('-')[0];
              const opacity = position.color_code.split('-')[1];
              this.colorCodes[position.pname] = colorCode;
              position.activeClass = {
                'background-color': colorCode,
                'background-opacity': opacity,
                'color': '#FFF',
                'border': '2px solid ' + colorCode
              };
              position.inactiveClass = {
                'background-color': 'transparent',
                'background-opacity': opacity,
                'color': colorCode,
                'border': '2px solid ' + colorCode
              };
            });
            this.curFilter.pname = this.movePlayer!=null?this.movePlayer.pick_rp:this.curplayer.pick_rp;
            this.curFilter.composed_of = this.movePlayer!=null?this.movePlayer.pick_cabbr:this.curplayer.pick_cabbr;
            this.filterPlayers();
          } else {
            this.playerData = [];
          }
          this.spinner.hide();
        });
      } else {
        this.spinner.hide();
        this.dialogRef.close(res);
      }
    });
  }

  selectNewPlayerForSwap(player) {
    this.showLoader=true;
    let postData = { "action": "add", "pposition": player.pn, "league_uuid": this.curleague.id, "user_uuid": this.curplayer.lgm_id, "player_uuid": player.id, "session_id": this.session_id, access_token: `${environment.DRAFT_ACCESS_TOKEN}` };
    this.newplayer = player;
    this.MyteamsService.addPlayerToSwap(postData).subscribe(res => {
      this.swap = res;
      this.showLoader=false;
      this.MyteamsService.getSwappedPlayers(this.curleague.id,res.uuid,this.session_id).subscribe(res => {
        this.swappedPlayers = res.entities;    
       });
    })
  }

  confirmSwap() {
    this.showLoader=true;
    let moved_pos_id="";
    let moved_player_id ="";
    if(this.movePlayer){
        moved_pos_id=this.movePlayer.gp_id;
        moved_player_id =this.movePlayer.pid;
    }
    let postData = { "add": this.newplayer.id, "drop": this.curplayer.id, "swap_session_id": this.swap.session_id, "league_uuid": this.curleague.id, "login_user_uuid": this.user.id, "moved_pos_id": moved_pos_id, "moved_player": moved_player_id };
    this.MyteamsService.updateSwapPlayer(postData).subscribe(res => {
      this.showLoader=false;
      res.curplayer = this.curplayer;
      res.newplayer= this.newplayer;
      res.session_id =this.swap.session_id;
      res.league_id = this.curleague.id;
      res.swap_uuid = this.swap.uuid;
      res.swappedPlayers = this.swappedPlayers;
      this.dialogRef.close(res);
    });
  }
  
  cancelSwap() {
    this.newplayer = {};
    this.swap = {};
    this.showLoader=false;
  }

  setFilter(position) {
    this.curFilter = position;
    this.filterPlayers();
  }

  filterPlayers() {
    let mapdata = this.playerData.map(player => {
      let avg = (player.fpts != null && player.gp != null && player.gp > 0) ? player.fpts / player.gp : 0;
      player.avg = this.naiveRound(avg,2)
      return player;
    });
    this.playerData  = mapdata;
    this.playerData = this.playerData.filter(player => {
      return (player.swap_cnf==1);
    });

    if (this.curFilter.pname == 'All') {
      this.filteredPlayers = this.playerData;
    } else {
      this.filteredPlayers = this.playerData.filter(player => {
        let found = false;
        player.pn.split(',').forEach(p => {
          if (this.curFilter.composed_of.split(',').indexOf(p) > -1) found = true;
        });
        return found;
      });
    }
    if (this.curSearch != '') {
      this.filteredPlayers = this.filteredPlayers.filter(player => {
        const regex = new RegExp(this.curSearch, 'gi');
        let fullName = player.fn + ' ' + player.ln;
        return (player.fn.match(regex) != null || player.ln.match(regex) != null || fullName.match(regex) != null);
      });
    }
    if (this.curTeam != '' && this.curTeam != 'All') {
      this.filteredPlayers = this.filteredPlayers.filter(player => {
        return (player.tn.match(this.curTeam) != null);
      });
    }
  }

  clickOnSearch() {
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 100);
    this.curSearch = '';
    this.curFilter = {
      pname: 'All'
    };
    this.filterPlayers();
    this.searchMode = !this.searchMode;
    this.animationState = this.animationState === 'out' ? 'in' : 'out';
  }

  updateSearch(value) {
    this.curSearch = value;
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.filterPlayers();
    }, 800);
  }

  closeSearch() {
    this.curSearch = '';
    this.filterPlayers();
  }

  updateTeam(event) {
    this.curTeam = event.value;
    this.filterPlayers();
  }

  openPlayerInfoBox(player, player_id, e) {
    if(player_id) {
      this.dialog.open(Playerinfobox2Component, {
        width: (this.isMobile) ? '90%' : '70%',
        height: 'auto',
        autoFocus: false,
        data: {
          isDraft: false,
          league: {
            game_id: this.curleague.leagueData.game_id,
            id: this.curleague.leagueData.league_id,
            abbr: this.games[this.curleague.leagueData.game_id],
            active_season_id: null
          },
          lgm_id: this.curleague.leagueData.lgm_id,
          players: [],
          player_data : {'pp' : player.pp, 'fn' : player.fn, 'ln' : player.ln},
          player_id
        }
      });
    }
  }

  naiveRound(num, decimalPlaces = 0) {
    var p = Math.pow(10, decimalPlaces);
    return Math.round(num * p) / p;
}

}